<div class="container">
  <img [src]="this.logo()" class="logo" />
  <br/>
  @if (this.username != null) {
    <edu-student-issues-home [inputUserName]="this.username"
    [inputFullName]="this.fullName"></edu-student-issues-home>
  }
</div>